import { Pipe, PipeTransform } from '@angular/core';
import { SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * FTC-WEB-03: Use this pipe for every [innerHTML] binding that renders
 * user-generated or backend-stored rich text.
 *
 * It runs the value through Angular's built-in HTML sanitizer first
 * (strips <script>, on* handlers, javascript: URLs, dangerous attributes)
 * and THEN marks the cleaned string as trusted SafeHtml.
 *
 * Usage in templates:
 *   <div [innerHTML]="content | safeHtml"></div>
 *
 * Never call bypassSecurityTrustHtml() directly without sanitizing first.
 */
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';
    // sanitize() removes dangerous content while preserving safe formatting tags.
    const clean = this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
    return this.sanitizer.bypassSecurityTrustHtml(clean);
  }
}
